import { createContext } from 'react'

import type { BrandConfig } from './types'

export interface ThemeContextValue {
  brand: BrandConfig
  colorMode: 'light' | 'dark'
  setColorMode: (mode: 'light' | 'dark') => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)
